/* global skinvars */
export default function configureSearch() {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = '//search.usa.gov/javascripts/remote.loader.js';
  document.getElementsByTagName('head')[0].appendChild(script);

  // This prevents the click from submitting the webforms form
  $('.skin-search-go').on('click', e => {
    e.stopImmediatePropagation();
    submitSearch($('.skin-search-input'));
  });

  // This is the function that submits the search
  function submitSearch($this) {
    const query = $this ? ($this.val() || $this.parent().find('input').val()) : '';
    const affiliate = skinvars.aid;
    window.location = '//search.usa.gov/search?query=' + DOMPurify.sanitize(query) + '&affiliate=' + affiliate + '&utf8=%26%23x2713%3B';
  }

  // This turns hides the autocomplete box if the user scrolls the page
  $(window).on('scroll',
    () => {
      $('#usasearch_sayt ul').hide();
    });
}

window.usasearch_config = {
  siteHandle: skinvars.aid,
  autoSubmitOnSelect: false,
};
